var cilUnderline = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,496H496V16H16ZM48,48H464V464H48Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M296,152h32v88a63.966,63.966,0,0,1-88,59.313V152h24V120H136v32h32v88a96,96,0,0,0,192,0V152h32V120H296Z' class='ci-primary'/><rect width='256' height='32' x='136' y='368' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilUnderline };

